function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.837,46.137V34.425c0-6.274-3.35-9.194-7.816-9.194  c-3.604,0-5.219,1.982-6.119,3.373V25.71h-6.79c0.09,1.917,0,20.428,0,20.428h6.79V34.729c0-0.61,0.044-1.22,0.224-1.657  c0.49-1.22,1.607-2.482,3.482-2.482c2.458,0,3.44,1.874,3.44,4.618v10.929H50.837z M22.959,22.922c2.367,0,3.842-1.569,3.842-3.531  c-0.044-2.003-1.475-3.528-3.797-3.528s-3.841,1.525-3.841,3.528c0,1.962,1.474,3.531,3.753,3.531H22.959z M26.354,46.137V25.71  h-6.789v20.427H26.354z M33.5,1l28.146,16.25v32.5L33.5,66L5.354,49.75v-32.5L33.5,1z"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 67 67",
    "aria-hidden": "true",
    focusable: "false",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.083538a6.svg";
export { ForwardRef as ReactComponent };